import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { instance } from '../../axios/AxiosInstance';
import { useUser } from '../../context/UserContext';

const TOKEN_KEY = 'glubesAppToken';

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!email.trim() || !password) {
      setError('Имэйл болон нууц үгээ оруулна уу.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await instance.post<{ message: string; token: string }>('signin', {
        email: email.trim(),
        password,
      });
      if (data.token) {
        localStorage.setItem(TOKEN_KEY, data.token);

        // Submit the real form to a hidden iframe so browsers observe a native
        // password-form submission and offer to save the credentials.
        if (formRef.current) {
          formRef.current.target = 'login-sink';
          formRef.current.submit();
          formRef.current.target = '';
        }

        try {
          const { data } = await instance.get('users');
          setUser(data.user);
          navigate('/dashboard', { replace: true });
        } catch {
          localStorage.removeItem(TOKEN_KEY);
          setError('Хэрэглэгчийн мэдээлэл ачааллахад алдаа гарлаа. Дахин оролдоно уу.');
        }
      } else {
        setError('Нэвтрэх амжилтгүй боллоо.');
      }
    } catch (err: unknown) {
      const res =
        err && typeof err === 'object' && 'response' in err
          ? (err as { response?: { status?: number; data?: { message?: string } } }).response
          : undefined;

      if (res?.status === 401) {
        setError('Нэвтэрч чадсангүй');
      } else {
        const msg = res?.data?.message ?? null;
        setError(msg || 'Нэвтрэхэд алдаа гарлаа. Дахин оролдоно уу.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Hidden sink for native form submit — triggers browser "Save password?" dialog */}
      <iframe
        name="login-sink"
        style={{ display: 'none' }}
        title="Нууц үг хадгалах — нууцлагдсан илгээлт"
        aria-hidden="true"
      />

      <div className="login-form-heading">
        <h1 className="h1">Дижитал номын систем</h1>
      </div>

      <div className="login-form-container">
        <form ref={formRef} action="#" className="login-form" onSubmit={handleSubmit}>
          {error && (
            <p className="form-alert form-alert--error" role="alert">
              {error}
            </p>
          )}
          <label>
            <span className="label-text login-space-label">Имэйл</span>
            <input
              type="email"
              id="email"
              name="email"
              className="input login-space-input"
              placeholder="name@tomko.mn"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </label>

          <label>
            <div className="login-field-row">
              <span className="label-text login-space-label">Нууц үг</span>
              <Link
                to="/forgot-password"
                state={{ email: email.trim() }}
                className="link-primary login-space-link"
              >
                Нууц үгээ мартсан уу?
              </Link>
            </div>
            <div className="login-input-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                className="input login-space-input login-input-with-icon"
                placeholder="Нууц үгээ оруулна уу"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
              <button
                type="button"
                className="login-toggle-password"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Нууц үг нуух' : 'Нууц үг харуулах'}
              >
                <span className="material-symbols-outlined" style={{ fontSize: 24 }}>
                  {showPassword ? 'visibility_off' : 'visibility'}
                </span>
              </button>
            </div>
          </label>

          <div className="login-submit-wrap">
            <button
              type="submit"
              className="btn-primary login-space-btn"
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? 'Нэвтрэрч байна...' : 'Нэвтрэх'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
